<template>
  <el-dialog
    :title="enable.title"
    :close-on-click-modal="false"
    :visible="enable.state"
    width="800px"
    :modal="false"
    @close="closeModal()"
    class="enable-dia"
  >
    <div class="count">
      <el-row :gutter="24">
        <el-col :span="12" class="el"
          ><label>关键字:</label
          ><el-input placeholder="请输入关键字" v-model="name"></el-input
        ></el-col>
        <el-col :span="12" class="end"
          ><el-button type="primary" icon="el-icon-search" @click="search"
            >查询</el-button
          ><el-button @click="toenable" :loading="loading">{{ enable.info }}</el-button></el-col
        >
      </el-row>
      <!-- 表格 -->
      <div class="table">
        <el-table
          ref="table"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          :loading="tableLoading"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            :prop="item.prop"
            :label="item.label"
            show-overflow-tooltip
            v-for="item in tableItem"
            :key="item.prop"
            :width="item.width || ''"
          ></el-table-column>
        </el-table>
        <div class="mt20 flex-box">
          <div class="flex-1"></div>
          <el-pagination
            background
            @size-change="changeSize"
            @current-change="changePage"
            :current-page="pageNum"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { enableList, startUsing } from "@/api/management/user";
export default {
  props: {
    enable: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tableLoading: false,
      loading:false,
      name: "",
      tableData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      specialUserId: "",
    };
  },
  created() {
    this.getTabledata();
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    handleSelectionChange(selection) {
      if (selection.length > 0) {
        this.specialUserId = selection[0].specialUserId;
      }
      if (selection.length > 1) {
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(selection.pop());
      }
    },
    // 条数
    changeSize(value) {
      this.pageSize = value;
      this.getTabledata();
    },
    // 上下页
    changePage(value) {
      this.pageNum = value;
      this.getTabledata();
    },
    async getTabledata() {
      this.tableLoading = true;
      let params = {
        current: this.pageNum,
        size: this.pageSize,
        name: this.name,
      };
      const { data } = await enableList(params);
      this.tableLoading = false;
      if (data.code == 0) {
        this.tableData = data.data.records;
        this.total = data.data.total;
      } else {
        this.$message.error(data.msg);
      }
    },
    search() {
      this.pageNum = 1;
      this.getTabledata();
    },
    async toenable() {
      if(this.specialUserId == ''||this.specialUserId == null||this.specialUserId == undefined){
        this.$message.error("请选择用户")
        return
      }
      let params = {
        userId: this.enable.userId,
        specialUserId: this.specialUserId,
      };
      this.loading = true
      const { data } = await startUsing(params);
      this.loading = false
      if(data.code == 0){
        this.$message.success("启用成功")
        this.$emit("close",true)
      }else{
        this.$message.error(data.msg)
      }
    },
  },
  computed: {
    tableItem() {
      return this.enable.tableItem;
    },
  },
  watch: {
    "enable.state"(newval) {
      if (newval) {
        this.$nextTick(() => {
          this.$refs.table.clearSelection();
          this.specialUserId = "";
          this.name = "";
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.enable-dia {
  .count {
    max-height: 55vh;
  }
}
.el {
  display: flex;
  align-items: center;
  label {
    width: 60px;
  }
}
.end {
  display: flex;
  justify-content: end;
}
.table {
  padding: 20px 0px;
}
/deep/thead .el-table-column--selection .cell {
  display: none;
}
</style>